// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-edit"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13.5 19.7865L13.5008 22.4999H16.2134L20.164 18.5493L17.4506 15.8359L13.5 19.7865Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V10M15 6.5V12M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.4506 15.836L13.5 19.7866L13.5008 22.5H16.2134L20.164 18.5494M17.4506 15.836L19.7866 13.5L22.5 16.2134L20.164 18.5494M17.4506 15.836L20.164 18.5494","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapEditIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-edit',
    ref,
    icon: element,
  },
));

MapEditIcon.displayName = 'MapEditIcon';

export default MapEditIcon;
